import { ReactNode } from "react";
import { ActionButton, ActionGrid, CardIllustration, CardRoot, CardTitle, CardTop } from "../Dashboard.styles";

export interface CardAction {
	id: string;
	label: ReactNode;
	icon: ReactNode;
	onClick: () => void;
	ariaLabel?: string;
	color?: string;
}

interface DashboardCardProps {
	title: ReactNode;
	illustration: ReactNode;
	accent: string;
	titleColor: string;
	actions: CardAction[];
	testId: string;
	status?: ReactNode;
}

export const DashboardCard = ({
	title,
	illustration,
	accent,
	titleColor,
	actions,
	testId,
	status
}: DashboardCardProps) => (
	<CardRoot
		accent={accent}
		data-testid={testId}
	>
		<CardTop>
			<CardIllustration color={titleColor}>{illustration}</CardIllustration>
			<CardTitle color={titleColor}>{title}</CardTitle>
			{status}
		</CardTop>
		<ActionGrid>
			{actions.map((action) => (
				<ActionButton
					key={action.id}
					color={action.color ?? "#006594"}
					onClick={action.onClick}
					aria-label={action.ariaLabel ?? (typeof action.label === "string" ? action.label : action.id)}
				>
					{action.icon}
					<span>{action.label}</span>
				</ActionButton>
			))}
		</ActionGrid>
	</CardRoot>
);
